import { Typography } from "@mui/material";
import React, { useState } from "react";

const truncationNumber = 50;
export const SeeMore = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const truncatedContent = text?.slice?.(0, truncationNumber) || ""; // Adjust the length as needed

  return text !== "" ? (
    <Typography>
      {isExpanded ? text : truncatedContent}
      {text?.length && text.length > truncationNumber && (
        <Typography
          component="span"
          sx={{ fontSize: 10, textDecoration: "none", cursor: "pointer" }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? " ...Less" : " ...More"}
        </Typography>
      )}
    </Typography>
  ) : (
    ""
  );
};
